import React from 'react';
import { Building2, Users, Target, Award } from 'lucide-react';
import Layout from '../components/layout/Layout';

const AboutPage = () => {
    return (
        <Layout>
            <div data-testid="about-page">
                {/* Hero */}
                <section className="bg-navy text-white py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">About Hotel Motel Club</h1>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            The premier marketplace connecting hotel industry professionals since 2020
                        </p>
                    </div>
                </section>

                {/* Mission */}
                <section className="py-16 bg-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid lg:grid-cols-2 gap-12 items-center">
                            <div>
                                <h2 className="font-heading text-3xl font-bold text-navy mb-6">Our Mission</h2>
                                <p className="text-gray-600 text-lg mb-4">
                                    Hotel Motel Club was founded with a simple mission: to create a dedicated marketplace 
                                    where hotel industry professionals can connect, trade, and grow their businesses.
                                </p>
                                <p className="text-gray-600 text-lg mb-4">
                                    Whether you're looking to buy hotel furniture, find qualified staff, source supplies, 
                                    or explore real estate opportunities, HMC is your one-stop destination.
                                </p>
                                <p className="text-gray-600 text-lg">
                                    We understand the unique needs of the hospitality industry and have built a platform 
                                    specifically designed to serve hoteliers, suppliers, and service providers.
                                </p>
                            </div>
                            <div className="grid grid-cols-2 gap-4">
                                <div className="bg-gray-50 rounded-lg p-6 text-center">
                                    <Building2 className="w-10 h-10 text-gold mx-auto mb-3" />
                                    <div className="font-heading text-3xl font-bold text-navy">500+</div>
                                    <p className="text-gray-600">Hotels Served</p>
                                </div>
                                <div className="bg-gray-50 rounded-lg p-6 text-center">
                                    <Users className="w-10 h-10 text-gold mx-auto mb-3" />
                                    <div className="font-heading text-3xl font-bold text-navy">1000+</div>
                                    <p className="text-gray-600">Active Members</p>
                                </div>
                                <div className="bg-gray-50 rounded-lg p-6 text-center">
                                    <Target className="w-10 h-10 text-gold mx-auto mb-3" />
                                    <div className="font-heading text-3xl font-bold text-navy">8</div>
                                    <p className="text-gray-600">Categories</p>
                                </div>
                                <div className="bg-gray-50 rounded-lg p-6 text-center">
                                    <Award className="w-10 h-10 text-gold mx-auto mb-3" />
                                    <div className="font-heading text-3xl font-bold text-navy">5</div>
                                    <p className="text-gray-600">Years Experience</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Values */}
                <section className="py-16 bg-gray-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h2 className="font-heading text-3xl font-bold text-navy text-center mb-12">Our Values</h2>
                        <div className="grid md:grid-cols-3 gap-8">
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Industry Focus</h3>
                                <p className="text-gray-600">
                                    We exclusively serve the hotel and hospitality industry, ensuring every listing 
                                    and every member is relevant to your business needs.
                                </p>
                            </div>
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Community First</h3>
                                <p className="text-gray-600">
                                    We believe in building a supportive community where industry professionals can 
                                    network, share knowledge, and help each other succeed.
                                </p>
                            </div>
                            <div className="bg-white rounded-lg p-6 shadow-sm">
                                <h3 className="font-heading text-xl font-bold text-navy mb-3">Accessibility</h3>
                                <p className="text-gray-600">
                                    With our COVID-19 Business Restart Promo, we're making it free for businesses 
                                    to advertise during these challenging times.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CTA */}
                <section className="py-16 bg-navy text-white">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h2 className="font-heading text-3xl font-bold mb-4">Ready to Join?</h2>
                        <p className="text-gray-300 mb-8 max-w-2xl mx-auto">
                            Create your free account today and start connecting with thousands of hotel industry professionals.
                        </p>
                        <a href="/advertiser/register" className="inline-block bg-gold hover:bg-amber-600 text-white px-8 py-3 rounded-lg font-semibold transition-colors">
                            Get Started Free
                        </a>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default AboutPage;
